export const locale = {
  back: "Voltar",
  close: "Fechar",
  last: "Último",
  next: "Próximo",
  open: "Abrir diálogo",
  skip: "Pular",
};
